module.exports = __webpack_public_path__ + "img/rd-doctor-result.39b6bccb.png";